export const Config = {
    appname: "W&W Kundenverwaltung"
};
